const getIPXUrl = (filename: string, width = 216) => `/_ipx/w_${width},f_webp/${filename}`;

export default getIPXUrl;
